const React = require('react');
const CancelablePromise = require('mn-utils/CancelablePromise');
const delay = require('mn-utils/delay');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const Collapse = require('@material-ui/core/Collapse').default;
const withState = require('../../../../../../utils/withState');
const {
  apiV2KycPersonalProfileSubmit,
} = require('../../../../../../api/merchant/kyc');
const Switch = require('../../../../../dumb/Switch/C');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading/B');
const ButtonSave = require('../../components/Button/Save');
const ButtonNext = require('../../components/Button/Next');

const {
  prepareItem,
  prepareItemForRequest,
  prepareItemForResponse,
} = require('./functions');
const Form = require('./Form');


module.exports = withState((setState, self, onMount) => {
  const handleProvider = handleProviderProvider(setState);
  const handleChangeImDirector = handleProvider('imDirector');
  const setAccountHolder = setChildProvider('accountHolder');
  const setDirector = setChildProvider('director');

  let _defaultState;

  function setChildProvider(key) {
    return (child) => {
      setState({
        [key]: {
          ...(self.state[key] || {}),
          ...child,
        },
      });
    };
  }
  function update() {
    delay(() => {
      const next = _defaultState || {};
      setState({
        imDirector: next.im_director,
        accountHolder: prepareItemForResponse(next.holder || {}),
        director: prepareItemForResponse(next.director || {}),
      });
    });
  }

  onMount(() => {
    self.props.onMount();
  });

  return (state, props) => {
    const {
      handleOpenConfirm,
      handleOpenConfirmRemove,
    } = props;
    const defaultState = props.defaultState;
    const {
      clicked,
    } = state;

    let imDirector = state.imDirector;
    imDirector === undefined && (imDirector = true);

    const accountHolder = state.accountHolder || {};
    const accountHolderItem = prepareItem(accountHolder);
    const director = state.director || {};
    const directorItem = prepareItem(director);
    const disabled = accountHolderItem.disabled
      || !imDirector && directorItem.disabled;

    _defaultState === defaultState || update(_defaultState = defaultState);


    function submit() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return CancelablePromise.reject();
      }
      setState({
        loading: true,
      });
      return apiV2KycPersonalProfileSubmit({
        im_director: imDirector,
        holder: prepareItemForRequest(accountHolder),
        director: imDirector ? null : prepareItemForRequest(director),
      }).finally(() => {
        setState({
          loading: false,
        });
      });
    }

    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <Form
          name="Account holder"
          documentTypePrefix="account_holder_"
          setState={setAccountHolder}
          clicked={clicked}
          handleOpenConfirm={handleOpenConfirm}
          handleOpenConfirmRemove={handleOpenConfirmRemove}
          data={accountHolderItem}
        />
        <div className="layoutRow fhaS fvaC">
          <Switch
            label="I’m a director"
            checked={imDirector}
            onChange={handleChangeImDirector}
          />
        </div>
        <Collapse
          in={!imDirector}
          timeout="auto"
          unmountOnExit
          className="w"
        >
          <Form
            className="pt40"
            name="Director"
            documentTypePrefix="director_"
            setState={setDirector}
            clicked={clicked}
            handleOpenConfirm={handleOpenConfirm}
            handleOpenConfirmRemove={handleOpenConfirmRemove}
            data={directorItem}
          />
        </Collapse>
        <div className="layoutRow fvaC fhaB mt34">
          <ButtonSave
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.onSubmit);
            }}
          />
          <ButtonNext
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.handleSubmitAndNext);
            }}
          />
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
